import { ReviewGetType } from "@swivl-mono/types"
import { Button, Checkbox, Spinner } from "@swivl-mono/ui"
import { useEffect, useMemo, useState } from "react"
import LocationsModel from "../../Models/Locations/Locations.Model"
import { NavBar } from "../../Models/NavBar/NavBar.Model"
import ReviewsModel from "../../Models/Reviews/Reviews.Model"
import { blankReviewCounts, getReviewsViewData, ReviewsManagerViewFilters } from "./Helpers/ReviewsViewHelper"
import { ReviewsManagerFiltersView } from "./Review/Components/Review.View.Filters"
import { ReviewsViewMultiSelect } from "./Review/Components/Reviews.View.MultiSelect"
import "./Reviews.View.scss"

export default function ReviewsView() {
  const { selectedReviews, reviews, archivedReviews } = ReviewsModel.useState()

  const [filters, setFilters] = useState<ReviewsManagerViewFilters>({
    responded: false,
    notResponded: true,
    starRating1: false,
    starRating2: false,
    starRating3: false,
    starRating4: false,
    starRating5: false,
    google: false,
    yelp: false,
    spot: false,
    stores: {},
  });

  const [reviewStatus, setReviewGetType] = useState<ReviewGetType>(ReviewGetType.UNARCHIVED);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);
  const [showMultiSelect, setShowMultiSelect] = useState<boolean>(false);
  const [showAllStores, setShowAllStores] = useState<boolean>(true);

  useEffect(() => {
    LocationsModel.getGroupsAndLocations(false)

    NavBar.set(
      null,
      <NavBar.Component.Title title={'Reviews'} />,
      null,
      'Conversations'
    );
  }, [])

  useEffect(() => {
    ReviewsModel.load(reviewStatus);
    setHasLoaded(true);
  }, [reviewStatus]);

  const displayedReviews = reviewStatus === ReviewGetType.UNARCHIVED ? reviews : archivedReviews;

  const { reviewViews, storesWithReviews, counts } = useMemo(() => {
    if (!displayedReviews) {
      return { reviewViews: [], storesWithReviews: [], counts: { ...blankReviewCounts } };
    }

    return getReviewsViewData(displayedReviews, filters, selectedReviews, showMultiSelect);
  }, [displayedReviews, filters, selectedReviews, showMultiSelect]);

  const selectAll = () => {
    ReviewsModel.setSelectedReviews(counts.selectableRows);
  };
  const selectNone = () => {
    ReviewsModel.setSelectedReviews({});
    setShowMultiSelect(false);
  };

  const allSelected = counts.selected > 0 && counts.selected === counts.filtered;

  return (<div className="ReviewsView">
    <div className="mainCol">
      <div className="topBar">
        <div className="topBarLeft">
          <Checkbox
            disabled={!displayedReviews || !displayedReviews.length}
            name="selectAll"
            checked={allSelected}
            label="Select All"
            onCheckedChange={() => {
              if (allSelected) {
                selectNone();
              } else {
                selectAll();
              }
            }}
          />
        </div>
        {counts.selected > 1 ? (
          <>
            <Button
              onClick={() => {
                setShowMultiSelect(true);
              }}
            >
              {" "}
              Reply to selected
            </Button>
          </>
        ) : null}
      </div>

      {reviews ? (
        reviewViews
      ) : (
        <div className="loadingReviews">
          <Spinner />
        </div>
      )}
    </div>
    <div className="sideCol">
      {showMultiSelect ? null : (
        <div className="sideColHeader">
          <div
            className={reviewStatus === ReviewGetType.UNARCHIVED ? "filterItem selected" : "filterItem"}
            onClick={() => setReviewGetType(ReviewGetType.UNARCHIVED)}
          >
            Open
          </div>
          <div
            className={reviewStatus === ReviewGetType.ARCHIVED ? "filterItem selected" : "filterItem"}
            onClick={() => setReviewGetType(ReviewGetType.ARCHIVED)}
          >
            Archived
          </div>
        </div>
      )}
      {showMultiSelect ? (
        <ReviewsViewMultiSelect reviews={selectedReviews} clearSelectedReviews={selectNone} />
      ) : (<ReviewsManagerFiltersView
        filters={filters}
        counts={counts}
        setFilters={setFilters}
        storesWithReviews={storesWithReviews}
        showAllStores={showAllStores}
        setShowAllStores={setShowAllStores}
      />
      )}
    </div>
  </div>
  );
}